import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.04",
  height: "19.333"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.517 19.333v-8.819h2.96l.443-3.438h-3.4V4.883c0-1 .276-1.673 1.7-1.673h1.82V.135A24 24 0 0 0 7.388 0c-2.624 0-4.42 1.6-4.42 4.543v2.533H0v3.437h2.968v8.819Z",
      "data-name": "f"
    }, null, -1)
  ])))
}
export default { render: render }